import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/isolation-mode.svg'


const _hoisted_1 = {
  id: "modal-mobile-warning",
  class: "modal modal-sm fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content px-3 pb-4" }
const _hoisted_4 = { class: "mt-2" }

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalMobileWarning',
  setup(__props, { expose: __expose }) {

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const router = useRouter()

  onMounted(() => {
    modal.value = new Modal('#modal-mobile-warning', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function toHomePage() {
    router.push('/')
    hide()
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("img", {
            alt: "modo de isolamento",
            src: _imports_0
          })
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "fs-6 px-2" }, [
            _createElementVNode("strong", null, "Ops!"),
            _createTextVNode(" Notamos que você está acessando esta página pelo smartphone. ")
          ])
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "fs-6 px-2" }, [
            _createTextVNode(" Lembre-se de que "),
            _createElementVNode("strong", null, "o seu Certificado Digital só pode ser instalado em um computador.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-primary w-100",
            onClick: toHomePage
          }, [
            _createVNode(IconComponent, {
              name: "house",
              class: "me-2"
            }),
            _cache[0] || (_cache[0] = _createTextVNode(" Página Inicial "))
          ])
        ])
      ])
    ])
  ]))
}
}

})